/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/no-extraneous-dependencies */
// Contact.js
import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import './index.css';

const Contact = () => {
  const formRef = useRef();
  const [form, setForm] = useState({
    name: '',
    email: '',
    message: '',
  });

  const [loading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { target } = e;
    const { name, value } = target;

    setForm({
      ...form,
      [name]: value,
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    emailjs
      .send(
        'service_8ty3k6s',
        'template_kect625',
        {
          from_name: form.name,
          to_name: 'Abdourahmane Jalloh',
          from_email: form.email,
          to_email: 'abdoulramanediallo44@gmail.com',
          message: form.message,
        },
        'PSuyS66q1OgzPuzoC',
      )
      .then(
        () => {
          alert('Thank you. I will get back to you as soon as possible. :)');
          setIsLoading(false);
          setForm({
            name: '',
            email: '',
            message: '',
          });
        },
        () => {
          setIsLoading(false);
          alert('Ahh, something went wrong. Please try again.');
        },
      );
  };

  return (
    <section className="container" id="contact">
      <h5>Contact Me</h5>
      <h2>Get In Touch</h2>

      <form
        className="contact-form"
        ref={formRef}
        onSubmit={handleSubmit}
      >
        <label htmlFor="name">Name</label>
        <input
          type="text"
          name="name"
          value={form.name}
          onChange={handleChange}
          placeholder="What's your name?"
          required
        />

        <label htmlFor="email">Email</label>
        <input
          type="email"
          name="email"
          value={form.email}
          onChange={handleChange}
          placeholder="What's your web address?"
          required
        />

        <label htmlFor="message">Message</label>
        <textarea
          rows={7}
          name="message"
          value={form.message}
          onChange={handleChange}
          placeholder="What you want to say?"
          required
        />

        <button type="submit">{loading ? 'Sending...' : 'Send'}</button>
      </form>
    </section>
  );
};

export default Contact;
